import { AsyncCustomersNav } from '@jira/navigation-apps__horizontal-nav-csm-customers/src/index.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { csmAppSidebarEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/csmAppSidebarEntryPoint.entrypoint.tsx';
import { l1CustomersProjectProviderResource } from '@jira/router-resources__customer-service-l1-customers-project-provider/src/l1CustomersProjectProviderResource.tsx';
import { csmCustomerContextTenantMigratedStatusResource } from '@jira/router-resources__service-desk-customer-service-customers-organizations-common/src/csmCustomerContextTenantMigratedStatusResource.tsx';
import { customerServiceProductsEntryPoint } from '@jira/spa-apps__customer-service-products/src/customerServiceProductsEntryPoint.entrypoint.tsx';
import { customerServiceManagementCrmImportModuleResource } from '@jira/customer-service__forge-extensions/src/crm-import/customerServiceManagementCrmImportModuleResource.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { csmProductsRoute } from '@jira/router-routes__customer-services-customers-routes/src/csmProductsRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';

const csmProductsPageEntryPoint = createPageEntryPoint({
	main: customerServiceProductsEntryPoint,
	leftSidebar: {
		sidebar: csmAppSidebarEntryPoint,
	},
});

export const csmProductsRouteEntry: Route = createEntry(csmProductsRoute, () => ({
	group: 'customer-service',
	perfMetricKey: 'customer-service.csm-products',
	layout: globalLayout,

	navigation: {
		horizontal: AsyncCustomersNav,
		sidebarId: SidebarIdCsmApp,
	},

	entryPoint() {
		if (!fg('berry-6285-customers-l1')) {
			return notFoundPageEntrypoint;
		}

		if (fg('csm_appification_standalone_navigation')) {
			return csmProductsPageEntryPoint;
		}

		return notFoundPageEntrypoint;
	},

	resources: [
		...getCustomerServiceL1NavigationResources(),
		l1CustomersProjectProviderResource,
		csmCustomerContextTenantMigratedStatusResource,
		customerServiceManagementCrmImportModuleResource,
	],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
